import styled from "styled-components";
import { FC } from "react";

import { MainCreationFormProps } from "./types";

export const FormWrapper: FC<MainCreationFormProps> = styled.div<MainCreationFormProps>`
  .ant-select-in-form-item.ant-select.ant-select-disabled .ant-select-selector,
  .ant-input-search.ant-select-selection-search-input .ant-input,
  .ant-input-number.ant-input-number-readonly {
    background-color: ${({ $isReadOnly }) => $isReadOnly && "#FFFFFF"};
    color: ${({ $isReadOnly }) => $isReadOnly && "rgba(0, 0, 0, 0.75)"};
    border-color: ${({ $isReadOnly }) => $isReadOnly && "#d9d9d9"};

    &:hover {
      border-color: ${({ $isReadOnly }) => $isReadOnly && "#d9d9d9"};
    }
  }

  input[readonly],
  .ant-select .ant-select-selector .ant-select-selection-search {
    background-color: ${({ $isReadOnly }) => $isReadOnly && "#FFFFFF"};
    border-color: #d9d9d9;
    box-shadow: none;
    color: rgba(0, 0, 0, 0.75);
    cursor: not-allowed;
    opacity: 1;
  }

  .ant-form-item {
    label.ant-form-item-required:not(
        .ant-form-item-required-mark-optional
      )::before {
      display: ${({ $isReadOnly }) => ($isReadOnly ? "none" : "inline-block")};
    }
  }

  .ant-form-item-label {
    min-width: 13rem;
  }
`;
